<template>
  <div>
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="i<3 && item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column v-if="item1.field != 'rk'" :key="j" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <!-- 针对二维码字段判断 -->
                  <template v-if="item1.fieldName == '二维码'">
                    <span v-if="isEmpty(scope.row[j])">--</span>
                    <el-popover v-else placement="left" popper-class="auto-width" trigger="hover" width="auto">
                      <img :src="scope.row[j]" class="qrcode-img" />
                      <img class="qr-code-holder" slot="reference" src="/static/image/qrcode.png" />
                    </el-popover>
                  </template>
                  <template v-else>
                    <span v-if="whichType(scope.row[j])==='string'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                    <!-- <span v-else-if="whichType(scope.row[j])==='array'" v-html="arrParse(scope.row[j])"></span> -->
                    <span v-else-if="whichType(scope.row[j])==='object'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                    <span v-else-if="whichType(scope.row[j])==='img'"><img style="width:100%;max-width:64px;" :src="columnValue(repliceHttps(scope.row[j]), item.moduleId)" alt="" srcset=""></span>
                    <span v-else-if="whichType(scope.row[j])==='url'"><a :href="scope.row[j]" target="_blank" rel="noopener noreferrer">{{columnValue(scope.row[j], item.moduleId)}}</a></span>
                    <span v-else-if="isEmpty(scope.row[j]) && i == 3 && item1.fieldName == '产品logo'"><img style="width:100%;max-width:64px;" src="~@/assets/defalut-img.png" alt=""></span>
                    <span v-else>{{ columnValue(scope.row[j], item.moduleId) || '--' }} </span>
                  </template>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
        </div>
      </title-block>
    </template>

    <title-block id="bm科创分" v-if="titles[3].num">
      <template slot="title">科创分</template>
      <EnterpriseScience />
    </title-block>

    <title-block id="bm新闻舆情" v-if="titles[4].num">
      <template slot="title">新闻舆情</template>
      <el-scrollbar ref="scrollbar" wrap-class="scrollbar-wrapper scrollbar-wrapper-maxheight" :style="newsList.length>3?'height:730px;':null">
        <div class="mr-16" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
          <NewsDocument v-for="(item,i) in newsList" :data="item" :key="item.id" />
          <p v-if="loading" class="text-aline mb-16">加载中...</p>
          <p v-if="newsList.length && noMore" class="text-aline mb-16">- 没有更多了 -</p>
        </div>
      </el-scrollbar>
    </title-block>
  </div>
</template>

<script>
import mixin from '../mixins/enterpriseTabs'
import 'echarts-wordcloud';
import { newsCluePage } from '../api/newClueApi'

import EnterpriseScience from '@/views/clue/components/enterpriseScience'
import NewsDocument from '@/views/industryChainNew/components/newsDocument.vue';
export default {
  mixins: [mixin],
  components: { EnterpriseScience, NewsDocument },
  name: 'Development',
  props: {
    hid: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      titles: [
        { type: '', label: '融资历程', num: 0, moduleId: '' },
        { type: '', label: '核心团队', num: 0, moduleId: '' },
        { type: '', label: '竞品信息', num: 0, moduleId: '' },
        { type: '', label: '科创分', num: 0, moduleId: '' },
        { type: '', label: '新闻舆情', num: 0, moduleId: '' },

        // { type: '', label: '产品信息', num: 0, moduleId: '' },
        // { type: '', label: '主营产品', num: 0, moduleId: '' },
        // { type: '', label: '商品数据', num: 0, moduleId: '', pageNum: 1 },
        // { type: '', label: '微信小程序', num: 0, moduleId: '' },
        // { type: '', label: '微信公众号', num: 0, moduleId: '' },
        // { type: '', label: '新浪微博', num: 0, moduleId: '' },
        // { type: '', label: '蓝V账号', num: 0, moduleId: '' },
        // { type: '', label: '网店信息', num: 0, moduleId: '' },
      ],
      titlesOld: [
        { type: '', label: '融资历程', num: 0, moduleId: '' },
        { type: '', label: '核心团队', num: 0, moduleId: '' },
        { type: '', label: '竞品信息', num: 0, moduleId: '' },
        { type: '', label: '产品信息', num: 0, moduleId: '' },
        { type: '', label: '主营产品', num: 0, moduleId: '' },
        { type: '', label: '商品数据', num: 0, moduleId: '', pageNum: 1 },
        { type: '', label: '微信小程序', num: 0, moduleId: '' },
        { type: '', label: '微信公众号', num: 0, moduleId: '' },
        { type: '', label: '新浪微博', num: 0, moduleId: '' },
        { type: '', label: '蓝V账号', num: 0, moduleId: '' },
        { type: '', label: '网店信息', num: 0, moduleId: '' },
      ],
      mainProductsWords: '',
      switchDiaplayFlag: true,
      newsList: [],
      loading: false
    }
  },
  computed: {
    noMore() {
      return this.titles[4].total <= this.newsList.length
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  watch: {
    'titles.4.num': {
      deep: true,
      immediate: true,
      handler: function (val) {
        val && this.newsCluePage()

      }
    },
  },
  inject: ['$companyStatus'],
  mounted() {
  },
  methods: {
    isEmpty(val) {
      return !val || val == '' || val == '-' || val == '--' || val == 'null'
    },
    switchDisplay() {
      this.switchDiaplayFlag = !this.switchDiaplayFlag
    },
    load() {
      this.newsCluePage()
    },
    async newsCluePage() {
      this.loading = true
      const { data, code } = await newsCluePage({ hid: this.$companyStatus.hid, pageNum:this.titles[4].pageNum })
      this.loading = false
      if (code == 200 && data) {
        this.newsList = [...this.newsList, ...(data.newsList || [])]
        this.titles[4].total = data.total
        this.titles[4].pageNum++
      }
    },
  }
}
</script>

<style scoped lang="scss">
.text-aline {
  text-align: center;
}
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}
/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}
.qr-code-holder {
  width: 32px;
  cursor: pointer;
}
.qrcode-img {
  width: 250px;
  height: 250px;
}
.product-list {
  li {
    //  cursor: pointer;
    width: 30.37%;
    float: left;
    margin-right: 24px;
    &:nth-of-type(3n) {
      margin-right: 0;
    }
    .img {
      position: relative;
      height: 168px;
      width: 100%;
      margin-bottom: 8px;
      img {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        //  width: 100%;
        max-width: 100%;
        max-height: 100%;
      }
      &.defalutImg {
        background: #f5f6f8;
      }
    }
    p {
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
  }
}
.mainProducts {
  position: relative;
  .qhicon {
    position: absolute;
    right: 0;
    top: -16px;
    z-index: 2;
    cursor: pointer;
  }
  .mainProductsWordsBox {
    border: 1px solid rgba(187, 190, 202, 0.5);
    padding: 14px 16px;
    box-sizing: border-box;
    height: 290px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    p {
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
  }
  .mainProductsWordsBox {
    margin-right: 40px;
  }
}
</style>
<style  lang="scss">
.auto-width {
  min-width: 0;
}
</style>
